'use client';
import styled from 'styled-components';

export const ModelPage = styled.div`
  display: flex;
  width: 100%;
  max-width: 900px;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  gap: 20px;

  hr {
    margin: 0;
  }
`;
